import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft, Vote, HandHeart, Trophy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";
import { Link } from "react-router-dom";
import { getSectionContent } from "@/data/cmsStore";
import { useState, useEffect } from "react";

const CTASection = () => {
  const { t, isRtl, lang } = useI18n();
  const Arrow = isRtl ? ArrowLeft : ArrowRight;

  const [cms, setCms] = useState(() => getSectionContent("cta", "home"));

  useEffect(() => {
    const handleCmsChange = () => setCms(getSectionContent("cta", "home"));
    window.addEventListener("cmsLayoutChanged", handleCmsChange);
    window.addEventListener("cmsLayoutDraftChanged", handleCmsChange);
    window.addEventListener("stagingModeChanged", handleCmsChange);
    return () => {
      window.removeEventListener("cmsLayoutChanged", handleCmsChange);
      window.removeEventListener("cmsLayoutDraftChanged", handleCmsChange);
      window.removeEventListener("stagingModeChanged", handleCmsChange);
    };
  }, []);

  return (
    <section className="py-10 bg-gradient-hero geometric-pattern relative overflow-hidden">
      <div className="container relative z-10">
        <motion.div
          className="text-center max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-5xl font-display font-bold text-primary-foreground mb-6">
            {cms[`cta_title_${lang}`] || (
              <>
                {t.cta.title1}<span className="text-accent">{t.cta.titleHighlight}</span>
              </>
            )}
          </h2>
          <p className="text-lg text-primary-foreground/80 font-body mb-10 max-w-xl mx-auto">
            {t.cta.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg" className="text-lg px-8 py-6 font-body font-semibold gap-2 bg-primary-foreground text-foreground hover:bg-primary-foreground/90" asChild>
              <Link to="/voter">
                <Vote className="w-5 h-5" />
                {cms[`cta_btn_${lang}`] || t.cta.btn1}
                <Arrow className="w-4 h-4" />
              </Link>
            </Button>
            <Button size="lg" variant="secondary" className="text-lg px-8 py-6 font-body font-semibold gap-2" asChild>
              <Link to="/engagement">
                <HandHeart className="w-5 h-5" />
                {t.cta.btn2}
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="text-lg px-8 py-6 font-body font-semibold gap-2 border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10" asChild>
              <Link to="/quiz">
                <Trophy className="w-5 h-5" />
                Quiz
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
